<template>
  <transition name="fade">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <form class="modal-container">
          <div class="modal-body">
            <span @click="$emit('close')">
              <Close icon="close" />
            </span>
            <div class="information">
              <span class="popup_head text-center text-primary">{{ $t("donation-modal.title") }}</span>
              <p>{{ $t("donation-modal.description") }}</p>
            </div>
          </div>
          <div class="modal-footer">
            <button v-ripple type="button" class="btn-active btn-full popup-btn btn-color"
              @click="$emit('pause', false)">
              <span class="popup-text block">{{ $t("donation-modal.dont-pause") }}</span>
            </button>
            <span class="pause-anyway" @click="$emit('close')">{{ $t('donation-modal.pause') }}</span>
          </div>
        </form>
      </div>
    </div>
  </transition>
</template>
<script>
import Close from '../UI/Close.vue'

export default {
  components: {
    Close
  },
  data() {
    return {

    }
  }
}
</script>
